import React from 'react';
import { palettes, MediumLightTitle, Body } from '@indigo-ag/component-module';
import i18next from 'core/i18n';

export const NoContactsFound: React.FunctionComponent = (): JSX.Element => {
  return (
    <div
      className="flex- flex-column"
      style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'left', textAlign: 'left', paddingTop: 40 }}
    >
      <MediumLightTitle style={{ color: palettes.brand.blue.base }}>{i18next.t('noContactsFound')}</MediumLightTitle>
      <Body>{i18next.t('noContactsMessage')}</Body>
    </div>
  );
};
